<template>
    <Modal @close="onClose">
        <template v-slot:content>
            <div v-if="videoId" class="video__modal">
                <div class="maintain-aspect-ratio" :class="{ 'is-blocked': showChoiceModal }">
                    <iframe
                        :src="youtubeEmbedUrl"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen></iframe>
                </div>
                <div v-if="showChoiceModal" class="video-consent">
                    <div class="video-consent__container">
                        <h3 class="video-consent__title">Watch Video</h3>
                        <p class="video-consent__description">
                            Optional cookies, including those that support the Multimedia Player, are currently disabled based on Your Provacy Choices settings. 
                        </p>
                        <p class="video-consent__description">
                            Choose <strong>Accept and Play Video</strong> to enable the Multimedia Player, including its associated Cookies. This may involve the collection and sharing of your viewing information by Youtube for analytics and advertising purposes.  
                        </p>
                        <p class="video-consent__description">
                            You can also choose to watch the video on YouTube.
                        </p>
                        <div class="video-consent__actions">
                            <button type="button" class="video-consent__button" @click="playEmbeddedVideo">
                                Accept and Play Video
                            </button>
                            <button type="button" class="video-consent__link" @click="watchOnYouTube">
                                Watch on YouTube
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>

    import Modal from '@/components/Modal'
    import axios from 'axios'
    import { hasMultimediaConsent, setTrustArcConsentLevel, shouldPromptMultimediaPlayerChoice } from '@/helpers/trustArcConsent'

    export default {
        name: 'TrailerModal',
        components: {
          Modal
        },
        data() {
            return {
                videoId: null,
                isConsent: false,
                showPlayerChoice: false
            }
        },
        computed: {
            youtubeEmbedUrl() {
                if (!this.videoId) {
                    return null
                }

                const autoplay = this.showChoiceModal ? 0 : 1
                return `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=${autoplay}&rel=0&showinfo=0`
            },
            youtubeWatchUrl() {
                if (!this.videoId) {
                    return null
                }

                return `https://www.youtube.com/watch?v=${encodeURIComponent(this.videoId)}`
            },
            showChoiceModal() {
                return this.showPlayerChoice || !this.isConsent
            }
        },
        mounted() {
            this.updateConsent()
            window.addEventListener('multimediaConsentChanged', this.updateConsent)
            this.loadJson()
        },
        beforeUnmount() {
            window.removeEventListener('multimediaConsentChanged', this.updateConsent)
        },
        methods: {
            onClose() {
                // Modal close is treated as decline; leave consent unchanged.
                this.isConsent = false
                this.showPlayerChoice = false
            },
            updateConsent() {
                this.isConsent = hasMultimediaConsent()
                this.showPlayerChoice = shouldPromptMultimediaPlayerChoice()
            },
            playEmbeddedVideo() {
                setTrustArcConsentLevel('multimedia')
                this.isConsent = true
                this.showPlayerChoice = false
            },
            watchOnYouTube() {
                if (!this.youtubeWatchUrl) {
                    return
                }

                window.open(this.youtubeWatchUrl, '_blank', 'noopener,noreferrer')
            },
            loadJson () {
                const videoIdParam = this.$route.params.videoId
                const gameIdParam = this.$route.params.id
                var urlparams = this.$helpers.getURLParameters(this.$route.query);//+urlparams
                axios.get(window.baseUrl + '/games.json' + urlparams)
                    .then((response) => {
                        for (let i=0;i<response.data.games.length;i++) {
                            let obj = response.data.games[i]
                            if (obj.id === gameIdParam) {
                                if (obj.youtubeTrailerId === videoIdParam) {
                                    this.videoId = videoIdParam //make sure youtube cms param was in cms
                                }
                            }
                        }
                        if (!this.videoId) {
                            window.location.href = '/404'
                        }
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
        }
    }

</script>
